import type { MaybeObservableValue } from '@amazon/vinyl-observable'
import { isTv } from '@/device/deviceConfig'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('openExternal')

/** A TV has no browser to open a web page in, so it hands the page to the phone as a QR. */
export function openExternal(url: string, title?: MaybeObservableValue<string>): void {
    if (!isTv()) {
        window.open(url, '_blank', 'noopener,noreferrer')
        return
    }
    import('@/components/PhoneHandoffModal')
        .then(({ openPhoneHandoff }) => openPhoneHandoff({ title: title ?? url, url }))
        .catch(errorHandler)
}
